import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    body:null,
    token:null,

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
